<script>
  import { createEventDispatcher } from "svelte";

  export let keys;
  export let color;

  const dispatch = createEventDispatcher();

  const dispatchKeyClick = (event) => {
    dispatch("keyClick", event);
  };
</script>

{#each keys as row}
  <div>
    {#each row as key}
      <img
        id="{color}-{key}"
        class="key"
        alt={key}
        src="/img/{color}-{key}.png"
        width="32"
        height="32"
        on:click={dispatchKeyClick}
      />
    {/each}
  </div>
{/each}

<style>
  img.key {
    margin: 1px;
    cursor: pointer;
  }
</style>
